// extracted by mini-css-extract-plugin
module.exports = {"product-support-folder":"Folder_product-support-folder__oZ_cb"};